import React from 'react'
import { useTheme } from 'styled-components'
import Button from '../../common/Button'

import { Container, Flex } from '../../styleguide/layout'
import { H2, P } from '../../styleguide/typography'

const Hero = () => {

  const theme = useTheme()

  return (
    <Container height="100vh" margin="8rem 0 0 0">
      <Flex items="center" height="100%" direction="column" justify="center" gap="1rem">
        <H2 align="center" textTransform="uppercase">MULA <span style={{ color: theme.colors.secondary }}> Wallet</span></H2>
        <P maxWidth="650px"  margin= "0 auto 30px" align="center">
          Bringing the African community to your fingertips. 
          The Mula wallet is an easy-to-use multi-chain and multi-currency wallet.
        </P>

        <Button noIcon text="START USING MULA" variant="primary" to="" />
      </Flex>
    </Container>
  )
}

export default Hero